import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useLocalization } from "@fluent/react";
import { RoutingNumberTextInput } from "cerulean";

import { useLibrary } from "byzantine/src/dbbl/providers/useLibrary.hook";
import styles from "./RecipientDrawer.module.scss";

export default function RoutingNumberInput({value, routingType, ...props}: React.ComponentProps<typeof RoutingNumberTextInput> & { routingType: "ach" | "fedwire" }) {
  const { l10n } = useLocalization();
  const { fetchApi, token } = useLibrary("network");

  const queryFn = () => (
    fetchApi(`institutions/${value}/${routingType}`)
      .then((response: {json: () => Promise<any>}) => response.json())
      .then((responseJson) => responseJson?.institution?.name)
  );
  const { data: institutionName, error } = useQuery({
    queryKey: ["institutions/routing_number/type", value, routingType, token],
    queryFn,
    retry: false,
    enabled: !!token && !!value && value.toString().length === 9,
  });

  return (
    <div>
      <RoutingNumberTextInput
        value={value}
        {...props}
        error={
          props.error ||
          (error
            ? l10n.getString("please-enter-a-valid-9-digit-routing-number")
            : undefined)
        }
      />
      {institutionName && (
        <div className={`margin--top--xs nds-input-subline ${styles.institutionDetails}`}>
          <span className="narmi-icon-bank"></span>
          <span className="fontColor--secondary">
            {institutionName}
          </span>
        </div>
      )}
    </div>
  );
}